import { render } from "./MedicalMenu.vue?vue&type=template&id=7b8e6db4"
import script from "./MedicalMenu.vue?vue&type=script&lang=js"
export * from "./MedicalMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__